export const headers = [
  {
    key: "ticketId",
    label: "Ticket ID",
    width: "13.36%",
  },
  {
    key: "providerName",
    label: "Provider Name",
    width: "25.91%",
  },
  {
    key: "subject",
    label: "Subject",
    width: "33%",
  },
  {
    key: "status",
    label: "Status",
    width: "16%",
  },
  {
    key: "dateRaised",
    label: "Date Raised",
    width: "11.49%",
  },
  {
    key: "action",
    label: "Action",
    width: "5.91%",
  },
];

export const closedHeaders = [
  {
    key: "ticketId",
    label: "Ticket ID",
    width: "13.9%",
  },
  {
    key: "providerName",
    label: "Provider Name",
    width: "25.91%",
  },
  {
    key: "subject",
    label: "Subject",
    width: "33%",
  },
  {
    key: "status",
    label: "Status",
    width: "16%",
  },
  {
    key: "dateRaised",
    label: "Date Raised",
    width: "11.49%",
  },
  {
    key: "dateClosed",
    label: "Date Closed",
    width: "11.49%",
  },
  {
    key: "action",
    label: "Action",
    width: "5.91%",
  },
];

export const STATUS_OPTIONS = [
  { label: "Open", value: "Open" },
  { label: "In Progress", value: "In Progress" },
];

export const actionOptions = (ticketStatus = "Open") => {
  if (ticketStatus !== "Closed") {
    return [
      {
        label: "View",
        value: "view",
        src: "",
        id: 1,
        disabled: false,
      },
      {
        label: "Mark As Closed",
        value: "markAsClosed",
        src: "",
        id: 2,
        disabled: false,
      },
    ];
  } else if (ticketStatus === "Closed") {
    return [
      {
        label: "Reopen",
        value: "reOpen",
        src: "",
        id: 1,
        disabled: false,
      },
    ];
  }
};
